module.exports = __webpack_public_path__ + "static/media/pizza-icon.51ed744d.png";